import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../types/actionParams';
import { ICustomViewActions } from './ICustomViewActions';

export class GetCustomizedViewActionsRequest extends Request<ISingleIdParams, ICustomViewActions> {
  constructor(id: string) {
    super('getCustomizedViewActions', { id: id });
  }
}
